import { render, staticRenderFns } from "./formModal.vue?vue&type=template&id=12abe4b8&scoped=true"
import script from "./formModal.vue?vue&type=script&lang=js"
export * from "./formModal.vue?vue&type=script&lang=js"
import style0 from "./formModal.vue?vue&type=style&index=0&id=12abe4b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12abe4b8",
  null
  
)

export default component.exports